import { accessibilityColors } from '@edulastic/colors'
import styled from 'styled-components'

export const LikeIconStyled = styled.div`
  max-width: 60px;
  height: ${({ height }) => height || '24px'};
  margin-left: ${({ ml }) => ml};
  padding-left: 24px;
  position: relative;
  display: inline-flex;
  align-items: center;
  svg {
    fill: ${(props) =>
      props.isLiked ? accessibilityColors.likeIcon.red : 'transparent'};
    stroke: ${(props) =>
      props.isLiked
        ? accessibilityColors.likeIcon.red
        : accessibilityColors.likeIcon.gray};
    stroke-width: 2;
    &:hover {
      fill: ${(props) =>
        props.isLiked ? 'transparent' : accessibilityColors.likeIcon.red};
      stroke: ${accessibilityColors.likeIcon.red};
      stroke-width: 2;
    }
  }
`
